import React from "react"
import PropTypes from "prop-types"

import { FaGithubSquare, FaShareSquare } from "react-icons/fa"

import {
  Wrapper,
  ImageStyled,
  ImageStyle,
  Info,
  Number,
  Header,
  Text,
  SubHeader,
  Tags,
  ProjectLink,
  Button,
} from "./Project.styled"

const Project = ({ description, title, github, stack, url, image, index }) => {
  return (
    <Wrapper>
      {image && (
        <ImageStyled fluid={image.childImageSharp.fluid} style={ImageStyle} />
      )}
      <Info>
        <Number>#{index + 1}.</Number>
        <Header>{title || "default title"}</Header>
        <Text>{description}</Text>
        <SubHeader>Technical Sheet</SubHeader>
        <Text>
          Code technologies and skills I got involved with while working on this
          project.
        </Text>
        <Tags>
          {stack.map(item => {
            return <span key={item.id}>{item.title}</span>
          })}
        </Tags>
        <ProjectLink>
          <Button href={url} target="_blank" rel="noreferrer">
            <span>Visit The Website</span>
            <FaShareSquare className="project-icon" />
          </Button>
          <Button href={github} target="_blank" rel="noreferrer">
            <span>Visit The Code </span>
            <FaGithubSquare className="project-icon" />
          </Button>
        </ProjectLink>
      </Info>
    </Wrapper>
  )
}

Project.propTypes = {
  title: PropTypes.string.isRequired,
  github: PropTypes.string.isRequired,
  url: PropTypes.string.isRequired,
  description: PropTypes.string.isRequired,
  image: PropTypes.object.isRequired,
  stack: PropTypes.arrayOf(PropTypes.object).isRequired,
}

export default Project
